import { all, takeLatest, put, call } from 'redux-saga/effects';
import { setUser } from './App.slice';
import { fetchUser } from './App.actions';
import { authProviderDefault } from '../../providers/auth-provider';
import { Claims, Roles, User } from '../../domains/app';
import { createUser, fetchProfile } from '../../service/Persons.service';
import moment from 'moment';

function* fetchUserSaga() {
  const accountInfo = authProviderDefault.getAccountInfo();
  if (accountInfo) {
    const claims: Claims = accountInfo.account.idTokenClaims as any;
    const { user } = yield call(fetchProfile);
    if (user?.id) {
      user.fullName = `${user.firstName} ${user.lastName}`;
      yield put(setUser(user));
    } else {
      debugger;
      const date = moment(claims.extension_BirthofDate, 'DD/MM/YYYY');
      const userModel: User = {
        b2CId: claims.oid,
        firstName: claims.given_name,
        lastName: claims.family_name,
        email: claims.emails[0],
        country: claims.country,
        birthDate: date.isValid() ? date.toDate() : new Date(),
        bodyWeightUpdated: new Date(),
        gender: parseInt(claims.extension_sex),
        bodyWeight: claims.extension_Bodyweight,
        height: claims.extension_Height,
        pid: claims.extension_PID,
        role: Roles.User,
      };
      const res: User = yield call(createUser, userModel);
      res.fullName = `${res.firstName} ${res.lastName}`;
      yield put(setUser(res));
    }
  }
}
// eslint-disable-next-line
export default function* () {
  yield all([takeLatest(fetchUser, fetchUserSaga)]);
}
